module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-bg3.png?fa9a37ce";